import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Autosuggest from "react-autosuggest";
import { getCountries } from "../../../Redux/reducer/countries";
import { escapedRegexCharacters } from "../../utils/functions";
import * as CountriesActions from "../../../Redux/actions/countriesActions";
import i18next from "i18next";

export class CountriesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      selectedValue: null,
      suggestions: [],
    };
  }

  componentDidMount() {
    const {
      countries,
      actions: { getCountries },
    } = this.props;

    if (countries.length <= 0) {
      return getCountries();
    }
    this.getSelectedValue(this.props.value);
  }

  componentDidUpdate() {
    const {
      state: { selectedValue },
      props: { value },
    } = this;

    if (selectedValue !== null && selectedValue.id !== value) {
      this.getSelectedValue(value);
    }
  }

  getSelectedValue = (countryId) => {
    if (countryId == 0) {
      this.setState({ selectedValue: null, value: "" });
    } else {
      this.props.countries.map((country) => {
        if (country.id == countryId) {
          this.setState({ selectedValue: country, value: country.name });
        }
      });
    }
  };

  getSuggestions = (value) => {
    const { countries } = this.props;
    const inputValue = escapedRegexCharacters(value.trim().toLowerCase());
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : countries.filter(
          (country) =>
            country.name.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  getSuggestionsValue = (country) => country.name;

  getShouldRenderSuggestions = () => {
    return true;
  };

  renderSuggestion = (country) => <div>{country.name}</div>;

  onChange = (event, { newValue, method }) => {
    if (method == "type" && this.state.selectedValue !== null) {
      // Limpiamos el valor seleccionado
      this.setState({ selectedValue: null });
    }
    this.setState({ value: newValue });
    // mandamos un valor por defecto en caso de que el usuario no seleccione nada
    this.props.onChange({ target: { name: this.props.name, value: 0 } });
  };

  onSuggestionSelected = (e, { suggestion }) => {
    this.setState({ selectedValue: suggestion });
    const target = {
      name: this.props.name,
      value: suggestion[this.props.valueAttr],
    };
    suggestion.target = target;
    this.props.onChange(suggestion);
  };

  onSuggestionFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  };

  onSuggestionClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  render() {
    const { value, suggestions } = this.state;
    // const { countries, onChange, name, value } = this.props;

    var inputProps = {
      placeholder: i18next.t("general.labels.placeholderCountry"),
      readOnly: this.props.readOnly,
      value,
      onChange: this.onChange,
      className: `input ${this.props.error ? "suggest-input-error" : ""}`,
    };

    return (
      <Autosuggest
        id={`Country-selection`}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionsValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        renderSectionTitle={() => {}}
        shouldRenderSuggestions={this.getShouldRenderSuggestions}
      />
    );
  }
}

CountriesComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    countries: getCountries(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(CountriesActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatch)(CountriesComponent);
